import { useAuthStore } from 'features/auth/stores/authStore';

import { apiClient } from '../client/apiClient';
import { ENDPOINTS } from '../config/endpoints';
import type { ApiResponse } from '../types/common.types';
import type {
  GetDetailedReportResult,
  GetSummaryReportResult,
  GetWeeklyReportResult,
  SmartDetailsResult,
  SmartSummaryResult,
  WorkLogQualityCategory,
} from '../types/reports.types';

const getWorkspaceId = (): string => {
  const workspaceId = useAuthStore.getState().user?.workspaceId;
  if (!workspaceId) throw new Error('No active workspace');
  return workspaceId;
};

export const reportsService = {
  getSummary: (params?: {
    from?: string;
    to?: string;
    userIds?: string;
    projectId?: string;
    clientId?: string;
    projectIds?: string;
    clientIds?: string;
    isBillable?: boolean;
    hasDescription?: boolean;
    descriptionSearch?: string;
    tagIds?: string;
    groupBy?: string;
  }) => {
    const wid = getWorkspaceId();
    return apiClient.get<ApiResponse<GetSummaryReportResult>>(ENDPOINTS.REPORTS.SUMMARY(wid), {
      params,
    });
  },

  getDetailedReport: (params?: {
    from?: string;
    to?: string;
    userIds?: string;
    projectId?: string;
    clientId?: string;
    projectIds?: string;
    clientIds?: string;
    isBillable?: boolean;
    hasDescription?: boolean;
    descriptionSearch?: string;
    tagIds?: string[];
  }) => {
    const wid = getWorkspaceId();
    return apiClient.get<ApiResponse<GetDetailedReportResult>>(ENDPOINTS.REPORTS.DETAILED(wid), {
      params,
    });
  },

  getWeeklyReport: (params?: {
    from?: string;
    to?: string;
    userIds?: string;
    projectId?: string;
    clientId?: string;
    projectIds?: string;
    clientIds?: string;
    isBillable?: boolean;
    hasDescription?: boolean;
    descriptionSearch?: string;
    tagIds?: string[];
  }) => {
    const wid = getWorkspaceId();
    return apiClient.get<ApiResponse<GetWeeklyReportResult>>(ENDPOINTS.REPORTS.WEEKLY(wid), {
      params,
    });
  },

  getSmartSummary: (params?: {
    from?: string;
    to?: string;
    userIds?: string;
    projectId?: string;
    clientId?: string;
    isBillable?: boolean;
    hasDescription?: boolean;
    descriptionSearch?: string;
  }) => {
    const wid = getWorkspaceId();
    return apiClient.get<ApiResponse<SmartSummaryResult>>(ENDPOINTS.REPORTS.SMART_SUMMARY(wid), {
      params,
    });
  },

  getSmartDetails: (params?: {
    from?: string;
    to?: string;
    userIds?: string;
    category?: WorkLogQualityCategory;
    projectId?: string;
    clientId?: string;
    isBillable?: boolean;
    hasDescription?: boolean;
    descriptionSearch?: string;
  }) => {
    const wid = getWorkspaceId();
    return apiClient.get<ApiResponse<SmartDetailsResult>>(ENDPOINTS.REPORTS.SMART_DETAILS(wid), {
      params,
    });
  },
};
